import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIsOnline } from './useIsOnline';

/**
 * Hook that redirects users from detail pages to parent routes when they go offline
 * Examples:
 * - /manage-ssccs/250925102333272 -> /manage-ssccs
 * - /receive-manifest/123 -> /receive-manifest
 * - /receipt-purchase-orders/456 -> /receipt-purchase-orders
 * - /settings/location/789 -> /settings/locations
 */
export const useOfflineRedirect = () => {
  const { isOnline } = useIsOnline();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect when going offline (not when already offline)
    if (!isOnline) {
      const currentPath = location.pathname;

      // Define routes that should redirect to parent when offline
      const redirectRoutes = [
        {
          pattern: /^\/manage-ssccs\/[^/]+$/,
          redirect: '/manage-ssccs'
        },
        {
          pattern: /^\/receive-manifest\/[^/]+$/,
          redirect: '/receive-manifest'
        },
        {
          pattern: /^\/receipt-purchase-orders\/[^/]+$/,
          redirect: '/receipt-purchase-orders'
        },
        {
          pattern: /^\/settings\/location\/[^/]+$/,
          redirect: '/settings/locations'
        }
      ];

      // Check if current path matches any redirect pattern
      const matchedRoute = redirectRoutes.find((route) => route.pattern.test(currentPath));

      if (matchedRoute) {
        console.log(`Going offline - redirecting from ${currentPath} to ${matchedRoute.redirect}`);
        navigate(matchedRoute.redirect, { replace: true });
      }
    }
  }, [isOnline, navigate, location.pathname]);
};
